// removed by extract-text-webpack-plugin
module.exports = {"ReturnButton":"BackIconButton__-loca-__3XmLC","ReturnButtonHelper":"BackIconButton__-loca-__1eKhw","Disable":"BackIconButton__-loca-__1r3h7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/BackIconButton/BackIconButton.css
// module id = 131
// module chunks = 0